import { ServerClient } from 'common/utils/http/http-clients';
import {
  ICitationConfigurationUpdate,
  ICommunitySettings,
  IDriveIdConfigurationUpdate,
  IDriveIdSettings,
  IGageConfigurationUpdate,
  IPayEaseConfigurationUpdate,
  IPlateScanConfigurationUpdate,
  ISmartPlateConfigurationUpdate,
  ISystemConfigurationRead,
  ISystemConfigurationUpdate,
  ITrafficLogArchiveConfigurationUpdate,
  IUpdateEIQVoiceConfiguration,
} from './configuration.service.types';

class ConfigurationService {
  async getSystemConfiguration(): Promise<ISystemConfigurationRead> {
    const res = await ServerClient.get<ISystemConfigurationRead>(`/configurations/system`);
    return res?.data;
  }
  async removeGateConfiguration(name: string): Promise<void> {
    await ServerClient.delete(`/configurations/system/gate?name=${name}`);
  }
  async updateGateConfiguraion(model: IGageConfigurationUpdate): Promise<any> {
    const res = await ServerClient.put<ISystemConfigurationRead>(`/configurations/system/gate`, model);
    return res?.data;
  }
  async createGateConfiguraion(model: IGageConfigurationUpdate): Promise<any> {
    const res = await ServerClient.post<ISystemConfigurationRead>(`/configurations/system/gate`, model);
    return res?.data;
  }
  async updateSystemConfiguration(
    model:
      | ISystemConfigurationUpdate
      | IPlateScanConfigurationUpdate
      | ISmartPlateConfigurationUpdate
      | IDriveIdConfigurationUpdate
      | ICitationConfigurationUpdate
      | IPayEaseConfigurationUpdate
      | ITrafficLogArchiveConfigurationUpdate
      | IUpdateEIQVoiceConfiguration,
  ): Promise<ISystemConfigurationRead> {
    const res = await ServerClient.patch<ISystemConfigurationRead>(`/configurations/system`, model);
    return res?.data;
  }
  async getCommunitySettings(): Promise<ICommunitySettings> {
    const res = await ServerClient.get<ICommunitySettings>(`/configurations/community`);
    return res?.data;
  }

  async getDriveIdSettings(): Promise<IDriveIdSettings> {
    const res = await ServerClient.get<IDriveIdSettings>(`/configurations/driveid`);
    return res?.data;
  }

  async getNSDisabledFieldsSettings(): Promise<any> {
    const res = await ServerClient.get<any>(`/configurations/north-star`);
    return res?.data;
  }
}

export const configurationService = new ConfigurationService();
export default configurationService;
